import { render, staticRenderFns } from "./ProductInputResume.vue?vue&type=template&id=3afcc4d1&scoped=true&"
import script from "./ProductInputResume.vue?vue&type=script&lang=js&"
export * from "./ProductInputResume.vue?vue&type=script&lang=js&"
import style0 from "./ProductInputResume.vue?vue&type=style&index=0&id=3afcc4d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afcc4d1",
  null
  
)

export default component.exports